import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
    root: {
        flex: 1,
        display: 'flex',
        minWidth: 500,
        justifyContent: 'space-between',
        margin: 'auto',
        marginBottom: 40,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        },
        '@media (max-width: 960px)': {
            minWidth: 'initial',
            textAlign: 'center'
        }
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 24,
        flexWrap: 'wrap',
        padding: '5px 0',
        '& > svg': {
            display: 'none'
        },
        '& > p': {
            fontSize: 14,
            fontWeight: 600
        },
        [theme.breakpoints.down('md')]: {
            '& > svg': {
                display: 'inline-block'
            }
        },
        '@media (max-width: 960px)': {
            '& > p': {
                margin: '0 auto',
                padding: 0,
                fontWeight: 500,
                fontSize: 18
            }
        }
    },
    list: {
        fontSize: 14,
        fontWeight: 400,
        maxWidth: 120,
        listStyle: 'none outside none',
        margin: 0,
        paddingLeft: 0,
        [theme.breakpoints.down('md')]: {
            padding: 10
        },
        transition: 'max-height .5s',
        '& a': {
            fontSize: 14
        },
        '& li': {
            lineHeight: '16px',
            marginBottom: 16
        },
        '@media (max-width: 960px)': {
            padding: 0,
            maxWidth: 'initial',
            margin: '0 auto 80px',
            textAlign: 'center',
            '& a': {
                fontWeight: 400,
                fontSize: 16
            }
        }
    },
    listItem: {
        textDecoration: 'none'
    }
}));

export const Menu = ({ data }) => {
    const { classes: clasess } = useStyles();

    return (
        <div className={clasess.root}>
            {data.map((menu, index) => (
                <aside key={index}>
                    <MenuItem menu={menu} />
                </aside>
            ))}
        </div>
    );
};

const MenuItem = ({ menu }) => {
    const { classes: clasess } = useStyles();

    return (
        <React.Fragment>
            <div className={clasess.title}>
                <Typography variant="body2">{menu.title}</Typography>
            </div>
            <ul className={clasess.list}>
                {menu.items.map(({ url, label, ...props }, index) => (
                    <li key={index}>
                        <Typography
                            variant="body2"
                            gutterBottom
                            component="a"
                            className={clasess.listItem}
                            href={url}
                            {...props}
                        >
                            {label}
                        </Typography>
                    </li>
                ))}
            </ul>
        </React.Fragment>
    );
};
